const mEditionMapPathTreeNodeActionsEditor = {
  mEditionMapPathTreeNodeActionsEditor: {
    actions: {
      createStep: 'Crear Paso',
      deleteContent: 'Eliminar',
      editContent: 'Editar Contenido',
      editName: 'Editar Nombre'
    }
  }
}

export default mEditionMapPathTreeNodeActionsEditor
